import React, { useState } from 'react';
import {
  createMaxDecimalDigitsValidator,
  createMaxFloatValidator,
  TextInput,
  validationFunctions,
  Validations,
} from '@/components/text-input';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { PixelRatio } from 'react-native';

export const PAR_INPUT_SIZE = 34 * PixelRatio.getFontScale();

const maxDecimalDigitsValidator = createMaxDecimalDigitsValidator(0, 2);
const maxFloatValidator = createMaxFloatValidator(999);

export const inputValidations = [
  (input: string) => {
    if (input === '.') {
      return true;
    }
    return (
      validationFunctions[Validations.POSITIVE](input) &&
      maxDecimalDigitsValidator(input) &&
      maxFloatValidator(input)
    );
  },
];

const parseParLevel = (parLevelText: string): number | null => {
  const parsedParLevel = Number(parLevelText);
  return isNaN(parsedParLevel) || parsedParLevel === 0 ? null : parsedParLevel;
};

interface Props {
  onParLevelChange: (nextValue: number | null) => void;
  parLevel: number | null;
}

export const ParLevelInput: React.FC<Props> = ({
  parLevel,
  onParLevelChange,
}) => {
  const [styles] = useStyles();

  const [displayValue, setDisplayValue] = useState(
    parLevel ? String(parLevel) : '',
  );

  return (
    <TextInput
      containerStyle={styles.container}
      inputContainerStyle={styles.inputContainer}
      keyboardType="decimal-pad"
      onBlur={() => {
        if (!parseParLevel(displayValue)) {
          // Clear display value if it's not a valid par level
          setDisplayValue('');
        }
      }}
      onChangeText={(text) => {
        setDisplayValue(text);
        onParLevelChange(parseParLevel(text));
      }}
      selectTextOnFocus
      style={[TYPOGRAPHY.small, styles.input]}
      validators={inputValidations}
      value={displayValue}
    />
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.stroke,
    borderRadius: 4,
    borderWidth: 2,
    height: PAR_INPUT_SIZE,
    width: PAR_INPUT_SIZE,
  },
  input: {
    ...FONTS.primaryBold,
    lineHeight: 16,
    paddingHorizontal: 0,
    textAlign: 'center',
  },
  inputContainer: {
    paddingVertical: 0,
  },
}));
